import { LocaleConfig } from "@ogs-gmbh/ngx-translate";
import { TranslationInfo } from "@shared/types/translation-info";
import { Locale } from "date-fns";
import { de, enUS, fr } from "date-fns/locale";

export const DATE_FNS_LOCALES: Record<string, Locale> = {
  de,
  en: enUS,
  fr
};
export interface LocalizedLocaleConfig extends LocaleConfig {
  localizedName: TranslationInfo;
}
export const LOCALES: LocalizedLocaleConfig[] = [
  {
    value: "de",
    localizedName: {
      defaultText: "Deutsch (Deutsch)",
      scope: "shared/locales",
      token: "german"
    },
    isSource: true
  },
  {
    value: "en",
    localizedName: {
      defaultText: "Englisch (English)",
      scope: "shared/locales",
      token: "english"
    }
  },
  {
    value: "fr",
    localizedName: {
      defaultText: "Französisch (Français)",
      scope: "shared/locales",
      token: "french"
    }
  }
];

